import { GetServerSidePropsContext } from "next"
import { filterExtensionsByCategory } from "../../../utils/filterExtensions"
import { SectionTitle } from "../../../components/SectionTitle"
import { ArrowLeftIcon } from "../../../components/icons/ArrowLeftIcon"
import { ExtensionCard } from "../../../components/ExtensionCard"
import { Extension } from "../../../types"
import Head from "next/head"
import { getCategories, getExtensions } from "../../../utils/api"
import Link from "next/link"
import { parseCategories } from "../../../utils/constants"
import { useRouter } from "next/router"
import { useTranslation } from "react-i18next"
import { currentLang } from "../../../utils/utils"
import { getLocalePaths } from "../../../utils/i18n.utils"

export const getStaticPaths = async () => {
    const categories = await getCategories();
    const localePaths = getLocalePaths()


    const categoriesPath = localePaths.map((locale) => {
        return categories.map(category => {
            return { params: { category: category.toString(), locale: locale.params.locale.toString() } }
        });
    }).flat()
    return {
        paths: categoriesPath,
        fallback: "blocking"
    }
}

export const getStaticProps = async (context: GetServerSidePropsContext) => {
    const url = context?.params?.category as string

    const extensions = await getExtensions()

    const extensionsByCategory = filterExtensionsByCategory(extensions.apps);

    return {
        props: {
            category: url,
            extensions: extensionsByCategory[parseCategories[url].toLowerCase()] || null
        },
        revalidate: 60 * 15
    }
}

interface CategoryPageProps {
    extensions: Extension[],
    category: string
}

const CategoryPage = ({ extensions, category }: CategoryPageProps) => {
    const { t } = useTranslation()
    const router = useRouter()
    return <>
        <Head>
            <title className="capitalize">Categoria: {t("categories." + parseCategories[category].toLowerCase())}</title>
            <meta name="description" key="desc" content={`Page of the category ${category}`} />
        </Head>
        <main className="px-16 py-4 ">
            <div className="ml-20">
                <SectionTitle>
                    <span className="capitalize">{t(`categories.${parseCategories[category].toLowerCase()}`)}</span>
                    <ArrowLeftIcon />
                    <Link href={`/${router.query.locale?.toString()}`} className="font-light">{t("goBack.volver")}</Link>
                </SectionTitle>
            </div>
            <section className="flex flex-wrap gap-8 justify-center pt-11 pl-[7px]">
                {extensions?.map(extension => {
                    return <div key={extension.name + extension.version}>
                        <ExtensionCard
                            dev_user={extension.dev_user}
                            client_id={extension.client_id}
                            href={extension.subdomain}
                            title={extension.name}
                            description={extension.description[router.query.locale?.toString() || currentLang + "_summary"]}
                            variant={extension.purchase_details.is_purchasable ? "premium" : "standard"}
                            icon={extension.logo_url}
                        />
                    </div>
                })}
            </section>
        </main>
    </>
}

export default CategoryPage